import Storage from '@/storage/Storage';
import Hammer from 'hammerjs';

export default async function({ store }) {

	// store.dispatch('setPlatform', info.platform);
	// store.dispatch('setDeviceInfo', info);

	store.dispatch('loadPendingAuth');

	if (process.client) {
		// Enable swiping to open the menu
		var swipe = new Hammer(document);
		swipe.on('swipeleft', (e) => {
			e.preventDefault();
			if (e.distance > 50) {
				store.dispatch('closeMenu');
			}
		});
	}

	Storage.get('intended').then(intended => {
		if (intended) {
			store.dispatch('setIntended', intended);
		}
	});

	// window.addEventListener('focus', () => {
	// 	// TODO - Refresh projects here. However, this can be triggered several times in a short span so we need to rate limit it
	// 	// console.log('window gained focus');
	// });
}
